module.exports = __webpack_public_path__ + "media/reskin-images/icon--check-circle-339bc6f8.svg";